import React from "react";
import { Box, Button, Typography } from "@mui/material";

const FeedbackButton: React.FC = () => {
  return (
    <Box
      component="a"
      href="https://forms.cloud.microsoft/e/CG9n1n5qC1"
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        position: "fixed",
        right: 20,
        bottom: 20,
        zIndex: 2000,
        textDecoration: "none",
      }}
    >
      <Button
        disableRipple
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: "999px",
          backgroundColor: "#fff",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
          padding: "6px 6px 6px 16px",
          minWidth: "auto",
          textTransform: "none", // 👈 ensures normal case
          "&:hover": {
            backgroundColor: "#f5f5f5",
          },
        }}
      >
        {/* Text */}
        <Typography
          sx={{
            color: "#2a3fbf",
            fontSize: "14px",
            fontWeight: 500,
            marginRight: "8px",
            textTransform: "none", // 👈 keeps it as written
          }}
        >
          Feedback
        </Typography>

        {/* Blue circular ? icon */}
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            backgroundColor: "#2a3fbf",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          ?
        </Box>
      </Button>
    </Box>
  );
};

export default FeedbackButton;
